/**
* @name: file-show-item
* @author: weiyong
* @date: 2024-03-23 17:06
* @description：file-show-item
* @update: 2024-03-23 17:06
*/
<template>
  <div v-if="fileAclInfo.readOnly" class="file-item">
    <span class="file-name">{{ fileItem.fileName }}</span>
    <span @click.stop="handlePreview" class="preview-btn remix-icon ri-eye-line" title="预览"></span>
    <span @click.stop="handleDown" class="preview-btn remix-icon ri-download-2-line1" title="下载"></span>
  </div>
  <div v-else class="flex-div file-show-item-div w100b flex-div-bet" style="flex-wrap: wrap;overflow: hidden;">
    <div class="file-left-area flex-div " style="width: calc(100% - 130px)">
      <div class="w100b" style="width:22px;display: flex;align-items: center;">
        <svg-icon
          :icon-class="getFileTypeIcon(fileItem)"
          :style="{
            width: '22px',
            height: '22px',
            marginRight: '5px',
          }"
        />
      </div>
      <div class="w100b flex-1">
        <div class="w100b fileName text-dian-dian" style="font-size:13px;padding:4px 0;">
          <a-tooltip>
            <template #title>{{ fileItem.fileName }}</template>
            {{ fileItem.fileName }}
          </a-tooltip>
        </div>
        <div class="file-info flex-div" style="flex:1;">
          <div class="time-div" :title="fileItem.createTime">{{ getTimeStr(fileItem.createTime) }}</div>
          <div class="file-size">{{ getFileSize(fileItem.fileSize) }}</div>
        </div>
      </div>
    </div>

    <div class="file-right-area flex-div" style="width: 124px;padding-right: 3px;">
      <a-tooltip>
        <template #title>下载附件</template>
        <a-button type="dashed" class="icon-btn-item">
          <div class="icon-btn">
            <span @click="handleDown"  class="remix-icon ri-download-2-line1"></span>
          </div>
        </a-button>
      </a-tooltip>


      <a-tooltip>
        <template #title>预览附件</template>
        <a-button type="dashed" class="icon-btn-item" v-if="fileAclInfo.preview">
          <div class="icon-btn">
            <span @click="handlePreview"  class="remix-icon ri-eye-line"></span>
          </div>
        </a-button>
      </a-tooltip>

      <!-- <a-tooltip>
        <template #title>编辑</template>
        <a-button type="dashed" class="icon-btn-item">
          <div class="icon-btn">
            <span @click="handleeditfile"  class="remix-icon ri-edit-line"></span>
          </div>
        </a-button>
      </a-tooltip> -->
      <a-tooltip>
        <template #title>删除附件</template>
        <a-button type="dashed" class="icon-btn-item" v-if="fileAclInfo.delete">
          <div class="icon-btn">
            <span @click="handleRemove"  class="remix-icon ri-delete-bin-line"></span>
          </div>
        </a-button>
      </a-tooltip>

    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';


export default defineComponent({
  components: {},
  name: "file-show-item",
});
</script>

<script lang="ts" setup>
import SvgIcon  from '../../SvgIcon.vue';
import {Tooltip as ATooltip} from 'ant-design-vue';
import {fixedTwoNumber} from 'xmgoing-utils';
import GoingUtils from "@/utils/goingUtils";
import {useFileOperation} from "@/components/xmFileComCtl/hooks/useFileOperation";
import { axiosHelpers } from "@/api/index";
import {qiankunWindow} from "vite-plugin-qiankun/dist/helper";
import {StorageUtils} from 'xmgoing-utils';
import SysConfigUtils from "@/utils/sysConfigUtils";

interface Props {
  businessId:string,
  fileItem: any,
  fileAclInfo: any,
}

const props = withDefaults(defineProps<Props>(), {
  businessId:"",
  fileAclInfo: {},
  fileItem: {}
});
const {fileItem} = toRefs(props);
window["wpsselData" + props.businessId] = function(dataselurl,selid) {
  let url = "http://localhost.fiddler:6661/visualObjectDetail/importExcel";
  url = "/api/xm-professional/dictList/exportTemplate";
  url = "/api/pe-attachment/v3/3rd/config";
  //url = dataSelUrl.value;
  const response = axiosHelpers.postJSON(dataselurl, {
    id:selid,
    current:1,
    size: 10
    });

  return response;
};
window["wpsselListData" + props.businessId] = function(dataselurl,fieldkey,selid) {
  let url = "http://localhost.fiddler:6661/visualObjectDetail/importExcel";
  url = "/api/xm-professional/dictList/exportTemplate";
  url = "/api/pe-attachment/v3/3rd/config";
  //url = dataSelUrl.value;
  const json = { current:1, size: 10 };
  json[fieldkey] = selid;
  const response = axiosHelpers.postJSON(dataselurl, json);

  return response;
};
window["wpsupData" + props.businessId] = function(upurl,upjson) {
  let url = "http://localhost.fiddler:6661/visualObjectDetail/importExcel";
  url = "/api/xm-professional/dictList/exportTemplate";
  url = "/api/pe-attachment/v3/3rd/config";
  //url = dataUpUrl.value;
  url = "/api/pe-attachment/attachment/list";
  let response;
  try {
    response = axiosHelpers.postJSON(upurl, upjson);
  } catch (error) {

  }
  return response;
};
window["wpsgetuserseal" + props.businessId] = function() {
  let url = "/api/pe-portal/seal/getSignByUser?userId=1";
  url = "/api/pe-portal/seal/getSignByUser";
  let response;
  try {
    response = axiosHelpers.get(url, {});
  } catch (error) {

  }
  return response;
};

window["wpsgetdeptseal" + props.businessId] = function() {
  let url = "/api/pe-portal/seal/getSealByOrg?orgId=1";
  url = "/api/pe-portal/seal/getSealByOrg";
  let response;
  try {
    response = axiosHelpers.get(url, {});
  } catch (error) {

  }
  return response;
};
window["wpsgetuserdeptseal" + props.businessId] = function() {
  let url = "/api/pe-portal/seal/getSealForUserByOrgIdOrUserId?userId=111&orgId=1111";
  url = "/api/pe-portal/seal/getSealForUserByOrgIdOrUserId?userId=111&orgId=1111";
  let response;
  try {
    response = axiosHelpers.get(url, {});
  } catch (error) {

  }
  return response;
};

window.getdataid = function() {
  return props.businessId;
};

// 在组件卸载前移除全局方法，防止内存泄漏
onBeforeUnmount(() => {
  delete window["wpsselData" + props.businessId];
  delete window["wpsselListData" + props.businessId];
  delete window["wpsupData" + props.businessId];
  delete window["wpsgetuserseal" + props.businessId];
  delete window["wpsgetudeptseal" + props.businessId];
  delete window["wpsgetuserdeptseal" + props.businessId];
});
const getFileSize = function (fileSize) {
  return fixedTwoNumber(fileSize / 1024) + 'kb'
}

const getTimeStr=function (timeStr){
  if((timeStr+'').length>10){
    return  (timeStr+'').substring(0,10);
  }
  return ''
}
const emit = defineEmits<{
  (event: "preview", value: any): void;
  (event: "remove", value: any): void;
  (event: "downFile", value: any): void;
}>();
//预览
const handlePreview = function () {
  emit('preview', unref(fileItem));
}
//编辑
const handleeditfile = function () {
      const fileinfo = unref(fileItem);
      let url = "/api/pe-attachment/v3/3rd/config";
      const appidres = axiosHelpers.get(url);
      appidres.then(async (data) => {
        switch (fileinfo.fileName.split('.')[fileinfo.fileName.split('.').length - 1].toLowerCase()) {
            case "jpg":
            case "png":
            case "jpeg":
            case "gif":
            case "WebP":
            case "SVG":
            case "BMP":
              GoingUtils.showWarningMsg("图片不允许编辑!");
              break;
            default:
              if (qiankunWindow.__POWERED_BY_QIANKUN__) {
                window.open(SysConfigUtils.staticUrl + "/static/web-office-sdk-solution-v2.0.7/test-up.html?pi="+props.businessId+"&a=" + data.data.data.appid + "&i=" + fileinfo.id + "&n=" + fileinfo.fileName + "&t=" + StorageUtils.getSessionItem('sessionId'));
              } else {
                if ((window as any).appObj.preview) {
                  window.open(SysConfigUtils.staticUrl + "/xm-erp/static/web-office-sdk-solution-v2.0.7/test-up.html?pi="+props.businessId+"&a=" + data.data.data.appid + "&i=" + fileinfo.id + "&n=" + fileinfo.fileName + "&t=" + StorageUtils.getSessionItem('sessionId'));
                } else {
                  window.open(SysConfigUtils.staticUrl + "/xm-vue-des/static/web-office-sdk-solution-v2.0.7/test-up.html?pi="+props.businessId+"&a=" + data.data.data.appid + "&i=" + fileinfo.id + "&n=" + fileinfo.fileName + "&t=" + StorageUtils.getSessionItem('sessionId'));
                }
              }
              break;
          }
      })
}
// 下载
const handleDown = () => {
  emit("downFile", unref(fileItem));
};

// 删除
const handleRemove = () => {
  GoingUtils.executeConfirm({
    content: '您确定删除该附件吗？', backFun: function () {
      emit("remove", unref(fileItem));
    }
  })
};
const {getFileTypeIcon} = useFileOperation();
</script>

<style type="text/css" lang="less">
.file-show-item-div {
  display: flex;


  .time-div {
    font-size: 12px;
    color: #666;
  }

  .file-size {
    font-size: 12px;
    color: #888;
    padding-left: 6px;
  }

  .file-right-area {
    align-items: center;
    display: flex;

    .remix-icon{
      padding:0 !important;
    }
    .ant-btn{
      padding: 4px 8px;
    }

    .remix-icon {
      font-size: 16px;
      cursor: pointer;
      color: #777;
      display: inline-block;
      padding-left: 6px;
    }
  }
}

.file-item {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
  max-width: 100%;

  .file-name {
    flex: 1 1 auto;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    vertical-align: middle;
  }

  .preview-btn {
    flex: 0 0 auto;
    width: 20px;
    height: 20px;
    font-size: 16px;
    cursor: pointer;
    color: #409eff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    padding: 0;
    line-height: 1;
    transition: all 0.3s;

    &:hover {
      color: #66b1ff;
      transform: scale(1.1);
    }
  }
}
</style>
